import { gql } from "@apollo/client";

export const ORGANIZATION_LOGIN = gql`
  query OrganizationLogin($email: String, $password: String, $orgId: Int) {
    organizationLogin(email: $email, password: $password, orgId: $orgId) {
      Token
      message
      userData {
        userId
        firstName
        lastName
        phone
        email
        companyEmail
        bloodType
        emergencyContact
        birthDate
        joiningDate
        leavingDate
        isActive
        gender
        address
        orgId
        maritalStatus
        role
        designation
        imageUrl
        department
        reportTo
        ctc
        portalRole
        loginCheck
        salaryTemplateId
        hasAcceptedPolicies
        isStudent
        studentApplicantId
        uploadResume
        orgDetails {
          logo
          name
          address
          erpType
        }
      }
    }
  }
`;

export const CREATE_ORGANIZATION = gql`
  mutation createOrganization($input: createOrganizationInput) {
    createOrganization(input: $input) {
      orgId
    }
  }
`;

export const GET_ORGANIZATIONBY_ID = gql`
  query organizationById($orgId: Int!) {
    organizationById(orgId: $orgId) {
      name
      industry
      primaryAdmin
      secondaryAdmin
      services
      websiteUrl
      requiredFeatures
      noOfEmployees
      email
      isSharedDb
      license
      orgId
      logo
      payrollCountry
      payrollCurrency
      freePeriod
      maxUsersCount
      totalPeriod
      address
      country
      state
      PAN
      CIN
      GST
      accountNumber
      bankName
      bankAddress
      IFSCCode
      swift
      isDeleted
      alias
      noOfDigits
      userIdLength
      allowedAlphabets
      studentIdlength
      studentAllowedAlphabets
      studentNoOfDigits
      phone
      pfAccountNo
      ESI
      lwf
      expiryDate
      history
      erpType
      membershipAllowedAlphabets
      membershipAddDate
    }
  }
`;

export const GET_ALL_ORGANIZATIONS = gql`
  query organization($orgId: Int) {
    organization(orgId: $orgId) {
      name
      industry
      primaryAdmin
      secondaryAdmin
      services
      websiteUrl
      requiredFeatures
      noOfEmployees
      orgId
      isSharedDb
      createdAt
      license
      licenseDetails {
        licensePeriod
      }
      orgUsageDetails {
        lastUsage
      }
      expiryDate
      logo
      email
      freePeriod
      maxUsersCount
      totalPeriod
      address
      country
      state
      PAN
      CIN
      GST
      accountNumber
      bankName
      bankAddress
      IFSCCode
      swift
      isDeleted
      phone
      pfAccountNo
      ESI
      lwf
      erpType
      membershipAllowedAlphabets
      membershipAddDate
    }
  }
`;

export const UPDATE_ORGANIZATION = gql`
  mutation updateOrganization($input: updateOrganizationInput) {
    updateOrganization(input: $input)
  }
`;

export const CREATE_ORGANIZATION_USER = gql`
  mutation createOrganizationUser($input: [createOrganizationUserInput]) {
    createOrganizationUser(input: $input) {
      firstName
      lastName
      email
      password
      orgId
      userId
    }
  }
`;

export const GET_ALL_USERORGANIZATIONS = gql`
  query userorganizations {
    userorganizations {
      userName
      firstName
      lastName
      email
      phone
      department
      password
      role
      Id
      orgId
      deptDetails {
        name
      }
      roleDetails {
        name
      }
    }
  }
`;

export const GET_USER_ORGANIZATIONBY_ID = gql`
  query userorganization($Id: Int!) {
    userorganization(Id: $Id) {
      userName
      firstName
      lastName
      email
      phone
      department
      role
      Id
    }
  }
`;

export const UPDATE_USER_ORGANIZATION = gql`
  mutation updateOrganizationUser($input: updateOrganizationUserInput) {
    updateOrganizationUser(input: $input)
  }
`;

export const DELETE_ORGANIZATIONUSER = gql`
  mutation deleteOrganizationUser($Id: Int!) {
    deleteOrganizationUser(Id: $Id)
  }
`;

export const DELETE_ORGANIZATION = gql`
  mutation deleteOrganization($orgId: Int!) {
    deleteOrganization(orgId: $orgId)
  }
`;

export const ORGANIZATIONS_BY_SUBDOMAIN = gql`
  query Organizationsbysubdomain($alias: String) {
    organizationsbysubdomain(alias: $alias) {
      orgId

      orgDetails {
        logo
      }
    }
  }
`;
export const RESEND_ORGANIZATION_EMAIL = gql`
  mutation ResendOrganizationEmail($orgId: Int) {
    resendOrganizationEmail(orgId: $orgId)
  }
`;
export const GET_ORGANIZATIONS = gql`
  query Organizations {
    organizations {
      orgId
      name
      industry
      email
      primaryAdmin
      secondaryAdmin
      noOfEmployees
      services
      isSharedDb
      websiteUrl
      logo
      createdAt
      modifiedAt
      requiredFeatures
      license
      licenseDetails {
        Id
        licensePeriod
      }
      expiryDate
      trail
      freePeriod
      maxUsersCount
      totalPeriod
      address
      country
      state
      PAN
      CIN
      GST
      accountNumber
      bankName
      bankAddress
      IFSCCode
      swift
      isDeleted
      alias
      payrollCurrency
      payrollCountry
      userIdLength
      allowedAlphabets
      noOfDigits
      phone
      pfAccountNo
      ESI
      lwf
      history
      erpType
      membershipAllowedAlphabets
      membershipAddDate
    }
  }
`;

export const GET_POLICIES_AGREEMENT_ORG_DETAILS = gql`
  query organizationById($orgId: Int!) {
    organizationById(orgId: $orgId) {
      name
      email
      address
      createdAt
    }
  }
`;
export const GET_ORGANIZATION_DOMAIN_MAPPING_STATUS = gql`
  query GetOrganizationDomainMappingStatus($alias: String) {
    getOrganizationDomainMappingStatus(alias: $alias) {
      status
      message
    }
  }
`;
export const RESEND_SUBSCRIPTION_EMAIL = gql`
  mutation ResendSubscriptionEmail($orgId: Int) {
    resendSubscriptionEmail(orgId: $orgId) {
      status
      message
    }
  }
`;
